import React from "react"
import Layout from "../components/Layout"

const contact = () => {
  return <Layout>
    <section  className="contact-page">
      <article className="contact-form">
        <h3>get in touch</h3>
        <form action="https://formspree.io/f/xdopdnwb" method="POST">
          <div className="form-group">
            <input type="text" name="name" placeholder="name" className="form-control"/>
            <input type="email" name="email" placeholder="email" className="form-control"/>
            <textarea name="message" rows="5" placeholder="message" className="form-control"></textarea>
          </div>
          <button type="submit" className="submit-btn btn">submit here</button>
        </form>
      </article>
      <div style={{margin: 3 + 'em', textAlign: "center"}}>
      <h3>Some Great Programming Quotes</h3>
      <br />
      <p><strong>“The most damaging phrase in the language is.. it's always been done this way” </strong>- <i>Grace Hopper</i></p>
      <br />
      <p><strong>“Programming isn't about what you know; it's about what you can figure out.” </strong>- 
      <i>Chris Pine</i></p><br />
      <p><strong>“The only way to learn a new programming language is by writing programs in it.” </strong>- 
      <i>Dennis Ritchie</i></p><br />
      <p><strong>“The best error message is the one that never shows up.” </strong>- 
      <i>Thomas Fuchs</i></p><br />
      </div>
    </section>
  </Layout>
}

export default contact
